import { PersonList, PersonDetail, CompanyList, CompanyDetail, NetworkingOverview } from './views'

// Hem IS the person list — `/persons` stays registered as an alias so older links/bookmarks
// keep resolving; it renders the same component.
export const routesConfig = (appName, displayName) => ([
  { path: `/${appName}/persons/:uuid`,   element: PersonDetail,  breadcrumb: 'Person' },
  { path: `/${appName}/persons`,         element: PersonList,    breadcrumb: 'Personer' },
  { path: `/${appName}/companies/:uuid`, element: CompanyDetail, breadcrumb: 'Företag' },
  { path: `/${appName}/companies`,       element: CompanyList,   breadcrumb: 'Företag' },
  { path: `/${appName}/networking`,      element: NetworkingOverview, breadcrumb: 'Nätverkande' },
  { path: `/${appName}/`,                element: PersonList,    breadcrumb: displayName },
])
